import { observer } from "mobx-react-lite";

import { MultiRowLayout } from "@/components/expression/inline-node/MultiRowLayout";
import { SingleRowLayout } from "@/components/expression/inline-node/SingleRowLayout";

import type {
  InlineNodeComponentProps,
  InlineNodeProps,
} from "@/components/expression/inline-node/types";

export const InlineNodeComponent = observer(function InlineNodeComponent({
  nodes,
  availableWidth,
  enableRows = false,
  ...props
}: InlineNodeComponentProps) {
  if (enableRows && typeof availableWidth === "number") {
    return <MultiRowLayout {...props} nodes={nodes} availableWidth={availableWidth} />;
  }

  return <SingleRowLayout {...props} nodes={nodes} />;
});

// eslint-disable-next-line no-var, no-mutable-exports -- var is hoisted, preventing TDZ in webpack's async module wrapper for circular deps
export var InlineNode: InlineNodeProps = observer(function InlineNode({ node, ...props }) {
  const { doc, nodes } = node;
  return <InlineNodeComponent doc={doc} node={node} nodes={nodes} {...props} />;
});
